var _style, _desc, _g, _g2, _path, _g3, _g4, _g5, _path2, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsSketch: "http://www.bohemiancoding.com/sketch/ns",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{display:none;} .st1{display:inline;} .st2{fill:#FFFFFF;fill-opacity:0;} .st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st4{display:none;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st5{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;} .st6{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;} .st7{display:none;fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;} .st8{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 43") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Welcome",
    sketchType: "MSPage",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    sketchType: "MSLayerGroup",
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-695",
    sketchType: "MSShapeGroup",
    className: "st2",
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    sketchType: "MSShapeGroup",
    d: "M49,22h-7V1c0-0.6-0.4-1-1-1H1C0.4,0,0,0.4,0,1v32c0,0.6,0.4,1,1,1h7v7 c0,0.4,0.2,0.7,0.5,0.9C8.7,42,8.8,42,9,42c0.2,0,0.4-0.1,0.6-0.2L21.3,34H22v7c0,0.6,0.4,1,1,1h5.7l11.7,7.8 c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.5-0.1c0.3-0.2,0.5-0.5,0.5-0.9v-7h7c0.6,0,1-0.4,1-1V23C50,22.4,49.6,22,49,22L49,22z M21,32c-0.2,0-0.4,0.1-0.6,0.2l-10.4,7V33c0-0.6-0.4-1-1-1H2V2h38v30H21L21,32z M48,40h-7c-0.6,0-1,0.4-1,1v6.1l-10.4-7 C29.4,40.1,29.2,40,29,40h-5v-6h17c0.6,0,1-0.4,1-1v-9h6V40L48,40z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 16.4,
    cy: 10,
    rx: 14.9,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.2,24.3c-2.3,0.6-4.9,0.9-7.7,0.9c-8.2,0-14.9-2.7-14.9-6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 31.3,
    y1: 10,
    x2: 31.3,
    y2: 16.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1.5,
    y1: 10,
    x2: 1.5,
    y2: 18.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.2,33.2c-2.6,1-5.9,1.6-9.7,1.6c-8.2,0-14.9-2.7-14.9-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.3,28.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1.5,
    y1: 19.5,
    x2: 1.5,
    y2: 28.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.1,40.6c-2.3,2.2-7.6,3.7-13.7,3.7c-8.2,0-14.9-2.7-14.9-6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1.5,
    y1: 29.2,
    x2: 1.5,
    y2: 38
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.6,14.9l-8.1,3.6l-0.3,0.1c-3,1.4-2.8,8.6,0.6,16.1s8.5,12.5,11.6,11.2l0.3-0.1l8.1-3.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9131 -0.4077 0.4077 0.9131 -8.0682 19.0674)",
    className: "st3",
    cx: 40.7,
    cy: 28.5,
    rx: 6,
    ry: 14.9
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.7,6.4c1.5,0.6,2.4,1.5,2.4,2.5c0,1-0.9,1.9-2.3,2.5H1.4v13.5h0c0.6,1.4,1.5,2.3,2.5,2.3 c1,0,1.9-0.9,2.5-2.4l0,0c0.5-0.8,1.1-1.2,1.8-1.2c1.7,0,3.1,2.9,3.1,6.4c0,3.5-1.4,6.4-3.1,6.4c-0.7,0-1.3-0.5-1.8-1.3l0,0 c-0.6-1.4-1.5-2.3-2.5-2.3c-1,0-1.9,0.9-2.5,2.4l0,0v13.3h13.5c1.4-0.6,2.3-1.5,2.3-2.5c0-1-1-1.9-2.4-2.5l0,0 c-0.7-0.5-1.2-1.1-1.2-1.8c0-1.7,2.9-3.1,6.4-3.1c3.5,0,6.4,1.4,6.4,3.1c0,0.7-0.5,1.3-1.3,1.8l0,0c-1.4,0.6-2.3,1.5-2.3,2.5 c0,1,0.9,1.9,2.4,2.5h13.3V35.1c0.6-1.5,1.5-2.4,2.5-2.4c1,0,2.1,1,2.8,2.4v0c0.5,0.8,1.1,1.2,1.8,1.2c1.7,0,3.1-2.9,3.1-6.4 c0-3.5-1.4-6.4-3.1-6.4c-0.6,0-1.2,0.4-1.7,1.1c-0.6,1.5-1.9,2.4-2.9,2.4c-1,0-1.9-0.9-2.5-2.3V11.4h-13h-0.3 c-1.5-0.6-2.4-1.5-2.4-2.5c0-1,0.9-1.8,2.3-2.5l0,0c0.8-0.5,1.3-1.2,1.3-1.9c0-1.7-2.9-3.1-6.4-3.1c-3.5,0-6.4,1.4-6.4,3.1 C13.5,5.2,14,5.8,14.7,6.4L14.7,6.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "44.9,20.3 44.9,49.1 5,49.1 5,20.3 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 9.2,
    className: "st5",
    width: 46.9,
    height: 11.1
  })), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 24.9,
    y1: 9.2,
    x2: 24.9,
    y2: 49.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M15.3,9.2C13,7,12.2,4.1,13.5,2.5c1.4-1.9,5-1.5,8,0.8c2.1,1.6,3.4,3.8,3.4,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M34.6,9.2c2.3-2.2,3.1-5.1,1.9-6.7c-1.4-1.9-5-1.5-8,0.8c-2.2,1.7-3.5,4.1-3.4,5.9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 25.3,
    cy: 39.9,
    rx: 3.6,
    ry: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.2,31c2.5-3.4,6.6-5.6,11.1-5.6c4.4,0,8.3,2,10.8,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.4,24.5c4.3-5.2,10.7-8.5,17.9-8.5c7,0,13.3,3.1,17.6,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.5,18.5C7.3,11.9,15.8,7.7,25.3,7.7c9.3,0,17.7,4.1,23.5,10.5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 12,
    className: "st5",
    width: 41.2,
    height: 26.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "4.6,12 25.2,30.8 45.8,12 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 31.4,
    y1: 25.1,
    x2: 45.8,
    y2: 38.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 4.6,
    y1: 38.3,
    x2: 18.9,
    y2: 25.2
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M24.9,8.2L19.5,19l-12,1.7c-1,0.2-1.5,1.4-0.7,2.2l8.7,8.5l-2.1,12c-0.2,1,0.9,1.8,1.8,1.4l11-5.6l10.5,5.5 c0.9,0.5,2-0.3,1.9-1.3l-2-11.9l8.7-8.5c0.8-0.7,0.3-2-0.7-2.2l-12-1.7L27.2,8.2C26.7,7.2,25.4,7.2,24.9,8.2z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 9.6,
    className: "st8",
    width: 31.4,
    height: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 24.4,
    y1: 34.2,
    x2: 24.4,
    y2: 45.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 18.2,
    y1: 34.2,
    x2: 10.1,
    y2: 48.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 30.5,
    y1: 34.2,
    x2: 38.7,
    y2: 48.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "8.7,9.6 8.7,6 40.1,6 40.1,9.6 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 24.4,
    y1: 6,
    x2: 24.4,
    y2: 1.4
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 24.9,
    cy: 25,
    r: 18.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 24.6,
    y1: 10.7,
    x2: 24.6,
    y2: 28.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 24.6,
    y1: 28.6,
    x2: 30.7,
    y2: 22.5
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 24.9,
    cy: 25,
    r: 23.6
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M19.4,34.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.6,34.3c0-2.5,1.2-4.8,3-6.4c2.7-2.5,4.4-6,4.4-10c0-8.4-7.6-15-16.3-13.3c-5.5,1.1-9.8,5.7-10.7,11.2 c-0.7,4.8,1.1,9.2,4.3,12.1c1.8,1.6,2.8,3.9,2.9,6.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 34.3,
    className: "st6",
    width: 12.2,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.2,41.7L30.2,41.7c0,2.1-1.4,3.7-3.1,3.7h-3.3c-1.7,0-3.1-1.7-3.1-3.7l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M23.7,34.3V19.6c0-1-0.8-1.9-1.9-1.9l0,0c-1,0-1.9,0.8-1.9,1.9l0,0c0,1,0.8,1.9,1.9,1.9h7.4 c1,0,1.9-0.8,1.9-1.9l0,0c0-1-0.8-1.9-1.9-1.9l0,0c-1,0-1.9,0.8-1.9,1.9l0,14.7"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M35.9,42.8c0-5.3-3.7-9.8-8.7-10.8v-2.7c1.9-0.9,3.2-2.8,3.2-5c0-0.5,0-2.3,0-2.8c0-3.1-2.5-5.5-5.5-5.5 c-3.1,0-5.5,2.5-5.5,5.5c0,0.5,0,2.3,0,2.8c0,2.2,1.3,4,3.1,4.9V32c-4.9,1.1-8.6,5.5-8.6,10.8H35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.3,19.8c0.8-0.5,1.7-0.9,2.6-1.1v-2.1c-1.4-0.7-2.3-2.1-2.3-3.7c0-0.4,0-1.7,0-2.1c0-2.3,1.9-4.2,4.2-4.2 S39,8.4,39,10.7c0,0.4,0,1.7,0,2.1c0,1.7-1,3.1-2.4,3.8v2.1c3.8,0.8,6.6,4.2,6.6,8.2H29.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M19.4,19.7c-0.8-0.5-1.7-0.9-2.6-1.1v-2.1c1.4-0.7,2.4-2.1,2.4-3.8c0-0.4,0-1.7,0-2.1c0-2.3-1.9-4.2-4.2-4.2 c-2.3,0-4.2,1.9-4.2,4.2c0,0.4,0,1.7,0,2.1c0,1.6,1,3,2.3,3.7v2.1c-3.7,0.8-6.5,4.2-6.5,8.2h12.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiSymbol);
export default __webpack_public_path__ + "static/media/wifi-symbol.31f43be0a728657d0be3721514de7210.svg";
export { ForwardRef as ReactComponent };